import React, {Component} from "react";
import PropTypes from "prop-types";
import {_getActiveUsersByPlan, _getFreeUsersByPlan} from "../../../../../services/apis/PlanAPI";

class TotalUsersByPlan extends Component {
    state = {
        total: 0,
        free: 0,
        loading: false
    };

    componentDidMount() {
        this._fetchTotalUsers();
    }

    _fetchTotalUsers = () => {
        this.setState({
            loading: true
        });

        const {plan} = this.props;

        _getFreeUsersByPlan(plan._id)
            .then(response => {
                const {success, data} = response;

                if (success) {
                    this.setState({
                        free: data
                    });
                }
            });

        _getActiveUsersByPlan(plan._id)
            .then(response => {
                const {success, data} = response;

                const updateState = {
                    loading: false
                };

                if (success) {
                    updateState.total = data;
                }

                this.setState(updateState);
            })
            .catch(error => {
                this.setState({
                    loading: false
                });
            });
    };

    render() {
        const {plan} = this.props;
        const {total, free, loading} = this.state;

        return (
            <div className="TotalUsersByPlan">
                <strong>{plan.title}</strong>: {loading ? '...' : total} users | {free} free users (bill &le; 1$)
            </div>
        );
    }
}

TotalUsersByPlan.propTypes = {
    plan: PropTypes.object.isRequired,
};

export default TotalUsersByPlan;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/statistic/UserByPlans/TotalUsersByPlan.js